<script>
  import { tick } from "svelte";
  import Header from "lib/components/Header.svelte";
  import Select from "@components/common/forms/Select.svelte";
  import { Pagination, TextInput, SectionWrapper, Button } from "paxray-components-svelte";

  import {
    DataTable,
    Toolbar,
    ToolbarContent,
    ToolbarSearch
} from "carbon-components-svelte";
  import ActionButtons from "../components/ActionButtons.svelte";
  import TimeTrackerDetails from "./TimeTrackerDetails.svelte";
  import Modal from "../../../../lib/components/Modal.svelte";
  import FormTimeOverview from "../components/FormTimeOverview.svelte";
  import CheckBox from "../components/CheckBox.svelte";
  import TimePickerInput from "../components/TimePickerInput.svelte";
  import { PLUS_ICON } from "@utils/icons.js";

  /// temporary data

  let headers = [
    { key: "zeit", value: "Zeit von -bis" },
    { key: "protocol", value: "Aufwand" },
    { key: "aufwand", value: "Mandant" },
    { key: "vj", value: "VJ" },
    { key: "aufwandspos", value: "Aufwandspos" },
    { key: "zuordnung", value: "Zuordnung" },
    { key: "objekt", value: "Objekt" },
    { key: "ma", value: "MA" },
    { key: "datum", value: "Datum" },
    { key: "kommentar", value: "Kommentar" },
    { key: "abr", value: "Abr.bar" },
    { key: "aktionen", value: "Aktionen" },
  ];

  let rows = [
    {
      id: "1",
      zeit: "12:04-14:35",
      protocol: "2h 32min",
      aufwand: "Mandant A",
      vj: 2022,
      aufwandspos: "Lorem",
      zuordnung: "Lorem Ipsum",
      objekt: "Lorem Ipsum",
      ma: 12345,
      datum: "01.05.2024",
      kommentar: "Est. 2022, Anlagen V",
      abr: false,
    },
    {
      id: "2",
      zeit: "14:37-16:07",
      protocol: "1h 30min",
      aufwand: "Mandant A",
      vj: null,
      aufwandspos: "Lorem",
      zuordnung: "Lorem Ipsum",
      objekt: "Lorem Ipsum",
      ma: null,
      datum: "01.05.2024",
      kommentar: "",
      abr: false,
    },
    {
      id: "3",
      // zeit: "17:00-17:23",
      zeit: "",
      // protocol: "23min",
      protocol: "",
      aufwand: "Mandant B",
      vj: 2023,
      aufwandspos: "Lorem",
      zuordnung: "Lorem Ipsum",
      objekt: "Lorem Ipsum",
      ma: 12345,
      datum: "",
      kommentar: "Est. 2023, Anlagen V",
      abr: false,
    },
  ];

  let predefinedYears = [
    { name: "2015", value: 2015 },
    { name: "2016", value: 2016 },
    { name: "2017", value: 2017 },
    { name: "2018", value: 2018 },
    { name: "2019", value: 2019 },
    { name: "2020", value: 2020 },
    { name: "2021", value: 2021 },
    { name: "2022", value: 2022 },
    { name: "2023", value: 2023 },
    { name: "2024", value: 2024 },
    { name: "2025", value: 2025 },
  ];

  let predefinedNumbers = [
    { name: "12345", value: 12345 },
    { name: "23456", value: 23456 },
    { name: "34567", value: 34567 },
  ];

  let filteredRowIds = [];
  let datePicker = "";
  let deletedRows = [];
  let openDetails = false;
  let openEditModal = false;
  let selectedRow = 0;
  let rowToEdit = {};
  let valueToEdit = { row: -1, key: "" };
  let pageSize = 15;
  let page = 1;
  let timeZeit = {};
  let rowBeforeEdit = {};

  $: {
    rowToEdit = rows.find((row) => row.id === selectedRow);
    if (rowToEdit) {
      rowBeforeEdit = JSON.parse(JSON.stringify(rowToEdit));
    }
  }

  $: deletedRows = [...deletedRows];

  function handleDelete(id) {
    if (isDeleted(id)) {
      deletedRows = deletedRows.filter((row) => row !== id);
    } else {
      deletedRows = [...deletedRows, id];
    }
    rows = [...rows];
  }

  function handleZoomIn() {
    console.log("zoom in");
    openDetails = !openDetails;
  }

  async function handleCloseModal() {
    openEditModal = false;
    const row = rows.find((row) => row.id === selectedRow);
    rowToEdit = rowBeforeEdit;
    rows = rows.filter((row) => row.id !== selectedRow);
    rows = [...rows, rowToEdit];
    await tick();
    const form = document.querySelector("#timeForm");
    if (form) {
      form.classList.remove("was-validated");
    }
    resetTimePickerValues(rowToEdit);
  }

  async function handleEdit(id) {
    selectedRow = id;
    rowToEdit = rows.find((row) => row.id === selectedRow);
    const form = document.querySelector("#timeForm");
    if (form) {
      const invalidInputs = form.querySelectorAll(".invalid");
      invalidInputs.forEach((input) => input.classList.remove("invalid"));
    }
    await tick();
    resetTimePickerValues(rowToEdit);
    openEditModal = true;
  }

  function addVj(e, id) {
    const index = rows.findIndex((row) => row.id === id);
    rows[index].vj = e.target.value;
    rows = [...rows];
  }

  function addMa(e, id) {
    const index = rows.findIndex((row) => row.id === id);
    rows[index].ma = e.target.value;
    rows = [...rows];
  }

  function handleAdd(e, id, key) {
    const index = rows.findIndex((row) => row.id === id);
    rows[index][key] = e.target.value;
    rows = [...rows];
    valueToEdit = { row: -1, key: "" };
  }

  function handleDateChange(event, id) {
    const index = rows.findIndex((row) => row.id === id);
    rows[index].datum = handleDateFormat(event.target.value);
    rows = [...rows];
    datePicker = false;
  }

  function isDeleted(id) {
    return deletedRows.includes(id);
  }

  function handleNewRow() {
    rows = [
      ...rows,
      {
        id: rows.length + 1,
        zeit: "",
        protocol: "",
        aufwand: "",
        vj: null,
        aufwandspos: "Lorem",
        zuordnung: "",
        objekt: "",
        ma: null,
        datum: "",
        kommentar: "",
        abr: false,
      },
    ];
  }

  function updateRow() {
    const form = document.querySelector("#timeForm");
    const inputs = form.querySelectorAll("input, select, textarea");
    let isValid = true;

    inputs.forEach((input) => {
      if (!input.checkValidity()) {
        input.classList.add("invalid");
        isValid = false;
      } else {
        input.classList.remove("invalid");
      }
    });
    const timePickerDiv = document.getElementById(
      `time-picker-${rowToEdit.id}`,
    );
    const von = rowToEdit.zeit.split("-")[0];
    const bis = rowToEdit.zeit.split("-")[1];
    if (von === "hh:mm" || bis === "hh:mm" || rowToEdit.zeit === "") {
      timePickerDiv.classList.add("isEmpty");
      isValid = false;
    } else {
      timePickerDiv.classList.remove("isEmpty");
    }

    if (!isValid) {
      return;
    }
    rows = rows.filter((row) => row.id !== selectedRow);
    rows = [...rows, rowToEdit];
    openEditModal = false;
  }

  function resetTimePickerValues(row) {
    const timePickerDiv = document.getElementById(`time-picker-${row.id}`);
    if (timePickerDiv) {
      const timePickerInputs = timePickerDiv.querySelectorAll("input");
      timePickerInputs.forEach((input) => {
        if (row.zeit === "") {
          input.value = "";
        }
        timePickerDiv.classList.remove("isEmpty");
        input.classList.remove("bx--text-input--invalid");
        input.removeAttribute("data-invalid");
      });
    }
    const timePickerDivInvalid = document.querySelector(
      ".bx--time-picker.bx--time-picker--light.bx--time-picker--sm.bx--select--light.bx--time-picker--invalid",
    );
    if (timePickerDivInvalid) {
      timePickerDivInvalid.classList.remove("bx--time-picker--invalid");
    }
  }

  function handleCheckeboxChange(value, id) {
    const index = rows.findIndex((row) => row.id === id);
    rows[index].abr = value;
    rows = [...rows];
  }

  function handleDateFormat(date) {
    const dateArray = date.split("-");
    const year = dateArray[0];
    const month = dateArray[1];
    const day = dateArray[2];
    return `${day}.${month}.${year}`;
  }

  function updateZeitTime(timeZeit, id) {
    if (timeZeit[id].von != "hh:mm" && timeZeit[id].bis != "hh:mm") {
      const time = `${timeZeit[id].von}-${timeZeit[id].bis}`;
      const index = rows.findIndex((row) => row.id === id);
      rows[index].zeit = time;
      rows[index].protocol = calculateProtocol(time);
      rows = [...rows];
    }
  }

  function calculateProtocol(zeit) {
    const [start, end] = zeit.split("-");
    const [startHour, startMinute] = start.split(":").map(Number);
    const [endHour, endMinute] = end.split(":").map(Number);

    let totalMinutes =
      endHour * 60 + endMinute - (startHour * 60 + startMinute);
    if (totalMinutes < 0) {
      totalMinutes += 24 * 60;
    }

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    return `${hours}h ${minutes}min`;
  }
</script>

<!-- <Header section="Time Tracker" breadcrumb="Home"> -->
<Header section="Zeiterfassung" breadcrumb="Übersicht">
  <Button kind="secondary" text="Assistant" />
  <Button kind="secondary" text="Send to DATEV" />
</Header>

<SectionWrapper fullscreen={true}>
  <div class="main" slot="main">
    {#if openDetails}
      <TimeTrackerDetails handleClose={handleZoomIn} />
    {:else}
      <DataTable
        {headers}
        {rows}
        sortable
        class="custom-table"
        {page}
        {pageSize}
      >
        <Toolbar style="margin-bottom: 10px;">
          <ToolbarContent>
            <ToolbarSearch
              shouldFilterRows
              persistent
              bind:filteredRowIds
              placeholder="Suche nach..."
            />
            <div>
              <Button
                kind="secondary"
                text="Neue Position"
                icon={PLUS_ICON}
                iconLeft
                on:click={handleNewRow}
              />
            </div>
          </ToolbarContent>
        </Toolbar>
        <svelte:fragment slot="cell-header" let:header>
          {header.value}
        </svelte:fragment>
        <svelte:fragment slot="cell" let:row let:cell>
          <div class="row_class" class:deleted-row={isDeleted(row.id)}>
            {#if cell.key === "aktionen"}
              <ActionButtons
                small
                handleDelete={() => handleDelete(row.id)}
                handleEdit={() => handleEdit(row.id)}
                handleRestart={() => handleDelete(row.id)}
                restart={isDeleted(row.id)}
                {handleZoomIn}
                details
              />
            {:else if cell.key === "abr"}
              <CheckBox
                id={row.id}
                key={cell.key}
                value={cell.value}
                handleChange={(e) =>
                  handleCheckeboxChange(e.target.checked, row.id)}
                disabled={isDeleted(row.id)}
              />
            {:else if cell.key === "zeit" && cell.value === ""}
              <TimePickerInput
                required
                bind:timeZeit
                rowId={row.id}
                inTable={true}
                id="zeit"
                updateCellValue={() => updateZeitTime(timeZeit, row.id)}
              />
            {:else if cell.key === "protocol"}
              {cell.value || "-"}
            {:else if cell.key === "vj" && cell.value === null}
              <Select
                id="page-size"
                variant="orange"
                options={predefinedYears}
                placeholder="Wählen"
                small
                disable={isDeleted(row.id)}
                on:change={(e) => addVj(e, row.id)}
              />
            {:else if cell.key === "ma" && cell.value === null}
              <Select
                id="page-size"
                variant="orange"
                options={predefinedNumbers}
                placeholder="Wählen"
                small
                disable={isDeleted(row.id)}
                on:change={(e) => addMa(e, row.id)}
              />
            {:else if cell.key === "datum" && cell.value === ""}
              {#if datePicker !== row.id}
                <Button
                  smallRounded={true}
                  icon={PLUS_ICON}
                  iconLeft={true}
                  text={cell.key}
                  on:click={() => (datePicker = row.id)}
                  disabled={isDeleted(row.id)}
                />
              {:else if datePicker === row.id && !isDeleted(row.id)}
                <TextInput
                  date={true}
                  id="datum"
                  placeholder={row.datum}
                  handleDateChange={(e) => handleDateChange(e, row.id)}
                  value={row.datum}
                  on:change={(e) => handleDateChange(e, row.id)}
                />
              {/if}
            {:else if cell.value === ""}
              {#if valueToEdit.row !== row.id || valueToEdit.key !== cell.key}
                <Button
                  smallRounded={true}
                  icon={PLUS_ICON}
                  iconLeft={true}
                  text={cell.key}
                  on:click={() =>
                    (valueToEdit = { row: row.id, key: cell.key })}
                  disabled={isDeleted(row.id)}
                />
              {:else if valueToEdit.row === row.id && valueToEdit.key === cell.key && !isDeleted(row.id)}
                <TextInput
                  id={cell.key}
                  placeholder={cell.value}
                  handleChange={(e) => handleAdd(e, row.id, cell.key)}
                  on:change={(e) => handleAdd(e, row.id, cell.key)}
                  on:focusout={() => (valueToEdit = { row: -1, key: "" })}
                />
              {/if}
            {:else}
              <span class:deleted-cell={isDeleted(row.id)}>
                {cell.value}
              </span>
            {/if}
          </div>
        </svelte:fragment>
      </DataTable>
      <Pagination
        bind:pageSize
        bind:page
        totalItems={filteredRowIds.length}
        pageSizes={[15, 30, 50]}
        itemsPerPageText="zeilen pro Seite"
        itemRangeText={(min, max, total) =>
          `${min} - ${max} of ${total} Positionen`}
        pageRangeText={(current, total) => ` of ${total} Seiten`}
      />
    {/if}
  </div>
</SectionWrapper>

<Modal
  modalHeading="Position hinzufügen/editieren"
  autowidth={true}
  secondaryButtonText="Abbrechen"
  primaryButtonText="Speichern"
  open={openEditModal}
  on:close={handleCloseModal}
  primaryButtonAction={updateRow}
  actions={true}
>
  <FormTimeOverview row={rowToEdit} />
</Modal>

<style>
  .main {
    width: 100%;
  }

  :global(
      .bx--table-toolbar .bx--toolbar-search-container-active,
      .bx--table-toolbar .bx--toolbar-search-container-persistent
    ) {
    flex: auto;
    transition: flex 175ms cubic-bezier(0.2, 0, 0.38, 0.9);
  }
  :global(
      .bx--table-toolbar .bx--toolbar-search-container-active .bx--search-input,
      .bx--table-toolbar
        .bx--toolbar-search-container-persistent
        .bx--search-input
    ) {
    visibility: inherit;
  }
  :global(
      .bx--table-toolbar
        .bx--toolbar-search-container-active
        .bx--search-input:focus,
      .bx--table-toolbar
        .bx--toolbar-search-container-persistent
        .bx--search-input:focus
    ) {
    outline: 2px solid #0f62fe;
    outline-offset: -2px;
    background-color: #e5e5e5;
  }

  :global(
      .custom-table
        .bx--table-sort
        .bx--table-sort.bx--table-sort--active
        .bx--table-sort--ascending
    ) {
    fill: white;
  }

  :global(
      .custom-table .bx--table-sort .bx--table-sort__icon-unsorted,
      .custom-table .bx--table-sort .bx--table-sort__icon
    ) {
    fill: white;
  }

  :global(.custom-table .bx--table-sort) {
    background-color: var(--pax-black) !important;
    color: white !important;
    fill: white;
  }

  :global(.custom-table .bx--table-sort):focus {
    outline: 2px solid var(--pax-black);
  }

  :global(.custom-table .bx--table-sort:first-child) {
    border-top-left-radius: 0.5rem !important;
    border-bottom-left-radius: 0.5rem !important;
  }

  :global(.custom-table .bx--table-sort:last-child) {
    border-top-right-radius: 0.5rem !important;
    border-bottom-right-radius: 0.5rem !important;
  }

  :global(.custom-table .bx--data-table thead) {
    background-color: var(--pax-black) !important;
    color: white !important;
    fill: white;
  }

  :global(.custom-table .bx--data-table th) {
    background-color: var(--pax-black) !important;
    color: white !important;
    fill: white;
  }

  :global(.custom-table .bx--data-table th:first-child) {
    border-top-left-radius: 0.5rem !important;
    border-bottom-left-radius: 0.5rem !important;
  }

  :global(.custom-table .bx--data-table th:last-child) {
    border-top-right-radius: 0.5rem !important;
    border-bottom-right-radius: 0.5rem !important;
  }

  /* body */
  :global(.custom-table .bx--data-table tbody tr) {
    /* border-top: 1px solid var(--pax-black) !important;
    border-bottom: 1px solid var(--pax-black) !important; */
    background-color: transparent;
    border-bottom-color: transparent;
    /* margin-top: 10px;    */
    /* border:1px solid var(--pax-black) !important;
    border-radius: 0.5rem !important;  */
    border: none;
  }

  /* :global(.custom-table .bx--data-table td) {
    background-color: #f2f2f2;
    border: none;   
    border-top:1px solid var(--pax-black) !important;
    border-bottom:1px solid var(--pax-black) !important;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-left: 0;
  }

  :global(.custom-table .bx--data-table td:first-child) {
    border-left: 1px solid var(--pax-black) !important; 
    border-top-left-radius: 0.5rem !important;
    border-bottom-left-radius: 0.5rem !important;
  }

  :global(.custom-table .bx--data-table td:last-child) {
    border-right: 1px solid var(--pax-black) !important; 
    border-top-right-radius: 0.5rem !important;
    border-bottom-right-radius: 0.5rem !important;
  } */

  .row_class {
    width: 100%;
  }

  /* .deleted-row {
    opacity: 0.5;
  } */
  .deleted-cell {
    text-decoration: line-through;
    opacity: 0.5;
  }
</style>
